<template>
  <div class="row">
    <div class="col-md-12">
      <p class="clearfix"></p>
      <price-profile-form
        :priceProfileData="priceProfileData"
        :route="route"
        @on-submit="onProfileSubmit"
      />
    </div>
  </div>
</template>

<script>
import PriceProfileForm from './PriceProfileForm.vue'

export default {
  components: {
    PriceProfileForm
  },
  props: {
    route: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      priceProfileData: this.route.params.priceProfileData || {}
    }
  },
  methods: {
    onProfileSubmit (model, isValid) {
      this.priceProfileModel = model
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Products/PriceProfileEdit.vue